<template>
  <div>
    <h2 class="content-block">Matching</h2>

    <div>
      <div>
        <h3 class="content-block">Actions</h3>
        <div class="content-block">
          To match, select entries totalling the same amount below
        </div>
        <div class="content-block">
          <DxButton
            :width="130"
            :disabled="!canMatch"
            text="Match"
            @click="match"
          />
          <DxButton
            :width="130"
            :disabled="!anySelected"
            text="Tech review"
            @click="startReview('INTERNAL_TECH')"
          />
          <DxButton
            :width="130"
            :disabled="!anySelected"
            text="Telco review"
            @click="startReview('TELCO')"
          />
          <DxButton
            :width="130"
            :disabled="!canAdjust"
            text="Adjust"
            @click="startAdjustment"
          />
        </div>
      </div>
      <div class="left-col">
        <h3>{{ source1Name }}</h3>
        <div>Selected amount: {{ currentAmount1 }}</div>
        <dx-data-grid
          :ref="'grid1'"
          :data-source="dataSource1"
          :show-borders="true"
          :key-expr="'row.id'"
          :remote-operations="false"
          :allow-column-reordering="false"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          :hover-state-enabled="true"
          :word-wrap-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :show-column-lines="true"
          :selection="{
            mode: 'multiple',
            allowSelectAll: false,
            showCheckBoxesMode: 'always',
          }"
          :on-cell-click="onCellClick"
          class="dx-card wide-card"
          width="100%"
          @selection-changed="on1SelectionChanged"
        >
          <dx-editing>
            <dx-texts confirm-delete-message="" />
          </dx-editing>
          <dx-column-chooser :enabled="false" />
          <dx-export
            :enabled="true"
            :file-name="`${currentDate}-unmatched-{{gateway}}-1`"
          />
          <dx-paging :page-size="pageSizes[0]" />
          <dx-pager
            :allowed-page-sizes="pageSizes"
            :show-page-size-selector="true"
            :show-navigation-buttons="true"
            :show-info="true"
          />
          <dx-filter-row :visible="true" />
          <dx-header-filter :visible="false" />
          <dx-filter-panel :visible="true" />
          <dx-column data-field="row.id" />
          <dx-column data-field="row.externalIds" caption="External Ids" />
          <dx-column
            data-field="row.timestamp"
            data-type="datetime"
            :format="config.intlDateTimeFormat"
            caption="Timestamp"
          />
          <dx-column
            data-field="row.amountWithCurrency"
            caption="Amount"
            alignment="right"
          />
          <dx-column data-field="row.rowTypeReversal" caption="Type" />
          <dx-column data-field="reviews.length" caption="Reviews" />
          <dx-column data-field="row.counterParty" />
        </dx-data-grid>
      </div>
      <div class="right-col">
        <h3>{{ source2Name }}</h3>
        <div>Selected amount: {{ currentAmount2 }}</div>
        <dx-data-grid
          :ref="'grid2'"
          :data-source="dataSource2"
          :show-borders="true"
          :key-expr="'row.id'"
          :remote-operations="false"
          :allow-column-reordering="false"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          :hover-state-enabled="true"
          :word-wrap-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :show-column-lines="true"
          :confirm-delete-message="''"
          :selection="{
            mode: 'multiple',
            allowSelectAll: false,
            showCheckBoxesMode: 'always',
          }"
          :on-cell-click="onCellClick"
          class="dx-card wide-card"
          width="100%"
          @selection-changed="on2SelectionChanged"
        >
          <dx-editing>
            <dx-texts confirm-delete-message="" />
          </dx-editing>
          <dx-column-chooser :enabled="false" />
          <dx-export
            :enabled="true"
            :file-name="`${currentDate}-unmatched-{{gateway}}-1`"
          />
          <dx-paging :page-size="pageSizes[0]" />
          <dx-pager
            :allowed-page-sizes="pageSizes"
            :show-page-size-selector="true"
            :show-navigation-buttons="true"
            :show-info="true"
          />
          <dx-filter-row :visible="true" />
          <dx-header-filter :visible="false" />
          <dx-filter-panel :visible="true" />
          <dx-column data-field="row.id" />
          <dx-column data-field="row.externalIds" caption="External Ids" />
          <dx-column
            data-field="row.timestamp"
            data-type="datetime"
            :format="config.intlDateTimeFormat"
            caption="Timestamp"
          />
          <dx-column
            data-field="row.amountWithCurrency"
            caption="Amount"
            alignment="right"
          />
          <dx-column data-field="row.rowTypeReversal" caption="Type" />
          <dx-column data-field="reviews.length" caption="Reviews" />
          <dx-column data-field="row.counterParty" />
        </dx-data-grid>
      </div>
      <div class="content-block clr">Max. 100,000 results shown</div>
    </div>
    <DxPopup
      :visible.sync="reviewPopupVisible"
      :drag-enabled="true"
      :close-on-outside-click="true"
      :show-title="true"
      :width="600"
      :height="450"
      title="Send for Review"
    >
      <div>
        <div class="dx-fieldset">
          <div class="dx-field">
            <div class="dx-field-label">Review type:</div>
            <div class="dx-field-value">{{ reviewType }}</div>
          </div>
          <DxTextArea
            id="review-comment"
            :height="250"
            :value.sync="reviewComment"
            placeholder="Enter review comment..."
          />
          <div class="dx-field">
            <DxButton
              id="mark-for-review"
              :width="180"
              text="Mark for review"
              @click="sendForReview"
            />
          </div>
        </div>
      </div>
    </DxPopup>
    
    <DxPopup
      :visible.sync="errorPopupVisible"
      :drag-enabled="false"
      :close-on-outside-click="false"
      :show-title="true"
      :width="300"
      :height="180"
      title="Error"
    >
      <div>
        <div class="dx-fieldset">
          <div class="dx-field">
            <div class="dx-field-value">Please enter a comment</div>
          </div>
          <div class="dx-field">
            <DxButton
              :width="80"
              text="Ok"
              @click="toggleErrorPopup"
            />
          </div>
        </div>
      </div>
    </DxPopup>
    
    <DxPopup
      :visible.sync="adjustmentPopupVisible"
      :drag-enabled="true"
      :close-on-outside-click="true"
      :show-title="true"
      :width="600"
      :height="450"
      title="Make Adjustment"
    >
      <div>
        <div class="dx-fieldset">
          <DxTextArea
            id="adjustment-comment"
            :height="250"
            :value.sync="adjustmentComment"
            placeholder="Enter adjustment comment..."
          />
          <div class="dx-field">
            <DxButton
              id="adjust-button"
              :width="180"
              text="Create adjustment"
              @click="createAdjustment"
            />
          </div>
        </div>
      </div>
    </DxPopup>
    <reviews-popup
      :show-popup.sync="showReviews"
      :row-id="openReviewRowId"
      :reviews="showReviewsData"
    />
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {DxColumn, DxColumnChooser, DxDataGrid, DxEditing, DxExport, DxFilterPanel, DxFilterRow, DxHeaderFilter, DxPager, DxPaging, DxTexts,} from 'devextreme-vue/data-grid'
import {DxButton} from 'devextreme-vue/button'
import {DxTagBox, DxTextArea} from 'devextreme-vue'
import {http} from '@/utils/http'
import {show} from '@/utils/show'
import {config} from '@/config'
import {showHttpError} from '../../utils/http'
import {DxPopup} from 'devextreme-vue/popup'
import ReviewsPopup from '@/components/reviews-popup'

export default {
  name: 'ViewMatch',
  components: {
    DxColumn,
    DxColumnChooser,
    DxDataGrid,
    DxEditing,
    DxExport,
    DxFilterRow,
    DxFilterPanel,
    DxHeaderFilter,
    DxPager,
    DxPaging,
    DxButton,
    DxTexts,
    // eslint-disable-next-line vue/no-unused-components
    DxTagBox,
    DxPopup,
    DxTextArea,
    ReviewsPopup,
  },
  data() {
    return {
      config,

	  gateway: this.$route.params.gateway,

      pageSizes: config.itemsPerPage,

      source1Name: null,
      dataSource1: null,
      selected1: [],
      currentAmount1: 0,

      source2Name: null,
      dataSource2: null,
      selected2: [],
      currentAmount2: 0,

      canMatch: false,
      canAdjust: false,

      anySelected: false,

      reviewPopupVisible: false,
      reviewComment: '',
      reviewType: null,

      adjustmentPopupVisible: false,
      adjustmentComment: '',
      
      errorPopupVisible: false,

      showReviews: false,
      openReviewRowId: 0,
      showReviewsData: [],
    }
  },
  computed: {
    ...mapState('user', [
      'gateways',
      'statementFormatLookup',
      'statementSourceLookup',
      'comparisonSourceLookup',
      'currencyLookup',
      'userLookup',
    ]),
    currentDate() {
      return new Date().toISOString().split('T')[0]
    },
  },
  created() {
    this.loadData()
  },
  destroyed() {},
  methods: {
    async loadData() {
      const unmatched = await http
        .get('reconciliation/admin/match/unmatched/' + this.gateway)
        .json()

      unmatched.sources.forEach((source) => {
        source.rows.forEach((rowAndReview) => {
          const row = rowAndReview.row
          row.externalIds = row.idAtComparisonSource + ' ' + row.idAtGateway
          row.amountWithCurrency =
            row.amount + ' ' + this.currencyLookup[row.currencyId].iso
          row.rowTypeReversal = row.rowType + (row.reversal ? '(rev.)' : '')

          rowAndReview.reviewsData = rowAndReview.reviews.map((review) => ({
            rowReview: review,
            review: source.reviews[review.reviewId],
            closed:
              review.reviewClosedId &&
              source.reviewsClosed[review.reviewClosedId],
          }))
        })
      })

      const source1 = unmatched.sources[0]
      this.source1Name = this.comparisonSourceLookup[
        source1.gateway + '_' + source1.source
      ].name
      this.dataSource1 = source1.rows

      const source2 = unmatched.sources[1]
      this.source2Name = this.comparisonSourceLookup[
	  source2.gateway + '_' + source2.source
      ].name
      this.dataSource2 = source2.rows
    },
    showRow(event) {
      this.$router.push({ path: `/row/${event.data.id}` })
    },
    grid1() {
      return this.$refs['grid1'].instance
    },
    grid2() {
      return this.$refs['grid2'].instance
    },
    getIdsAndRemoveSelections(grid, dataProperty) {
      const ids = this[dataProperty].map(
        (rowAndReviews) => rowAndReviews.row.id,
      )
      grid.beginUpdate()
      ids.map(grid.getRowIndexByKey).forEach((rowIndex) => {
        grid.deleteRow(rowIndex)
        grid.refresh()
      })
      grid.endUpdate()
      this[dataProperty] = []
      return ids
    },
    getAndRemoveSelections() {
      const ids1 = this.getIdsAndRemoveSelections(this.grid1(), 'selected1')
      const ids2 = this.getIdsAndRemoveSelections(this.grid2(), 'selected2')
      return ids1.concat(ids2)
    },
    match() {
      http
        .post('reconciliation/admin/match/save', {
          json: {
            ids: this.getAndRemoveSelections(),
          },
        })
        .then(() => {
          show.success('Match saved')
        })
        .catch((e) => {
          showHttpError(e)
        })
    },
    startAdjustment() {
      this.adjustmentPopupVisible = true
    },
    createAdjustment() {
      if (!this.adjustmentComment.length) {
         this.errorPopupVisible = true
         return
      }
      http
        .post('reconciliation/admin/match/saveAdjustment', {
          json: {
            ids: this.getAndRemoveSelections(),
            comment: this.adjustmentComment,
          },
        })
        .then(() => {
          show.success('Adjustment saved')
        })
        .catch((e) => {
          showHttpError(e)
        })
      this.adjustmentComment = ''
      this.adjustmentPopupVisible = false
    },
    startReview(type) {
      this.reviewPopupVisible = true
      this.reviewType = type
    },
    sendForReview() {
      if (!this.reviewComment.length) {
         this.errorPopupVisible = true
         return
      }
      this.reviewPopupVisible = false
      http
        .post('reconciliation/admin/review/save', {
          json: {
            rowIds: this.getAndRemoveSelections(),
            type: this.reviewType,
            comment: this.reviewComment,
          },
        })
        .then(() => {
          show.success('Review saved')
        })
        .catch((e) => {
          showHttpError(e)
        })
      this.reviewComment = ''
    },
    toggleErrorPopup() {
      this.errorPopupVisible = !this.errorPopupVisible
    },
    on1SelectionChanged({ selectedRowsData }) {
      this.selected1 = selectedRowsData
      this.selectionUpdated()
    },
    on2SelectionChanged({ selectedRowsData }) {
      this.selected2 = selectedRowsData
      this.selectionUpdated()
    },
    selectionUpdated() {
      this.anySelected = this.selected1.length || this.selected2.length
      const amount1 = this.selected1.reduce(
        (acc, row) => acc + row.row.amount,
        0,
      )
      const amount2 = this.selected2.reduce(
        (acc, row) => acc + row.row.amount,
        0,
      )
      this.currentAmount1 = amount1
      this.currentAmount2 = amount2
      if (this.selected1.length && this.selected2.length) {
        const currencyId = this.selected1[0].currencyId
        if (
          this.selected1.filter((row) => row.currencyId !== currencyId)
            .length ||
          this.selected2.filter((row) => row.currencyId !== currencyId).length
        ) {
          //currency mismatch
          this.canAdjust = this.canMatch = false
          this.currentAmount1 = 'Currency mismatch'
          this.currentAmount2 = 'Currency mismatch'
        } else {
          this.canMatch = amount1 === amount2
          this.canAdjust = !this.canMatch
        }
      } else {
        this.canMatch = false
        this.canAdjust = this.selected1.length || this.selected2.length
      }
    },
    onCellClick(e) {
      if (e.column.caption === 'Reviews' && e.rowType === 'data') {
        this.showReviews = true
        this.openReviewRowId = e.row.data.row.id
        this.showReviewsData = e.row.data.reviewsData
      }
    },
  },
}
</script>
<style lang="scss">
td[role='columnheader'] {
  text-align: center !important;
}

div.left-col {
  margin-top: 20px;
  width: 49%;
  float: left;
  clear: both;
}

div.right-col {
  margin-top: 20px;
  width: 49%;
  float: right;
}

#mark-for-review,
#adjust-button {
  margin-top: 10px;
}

#review-comment,
#adjustment-comment {
  border: 1px solid gray;
  padding: 5px;
}

div.clr {
  clear: both;
}
</style>
